import Smartlook from 'smartlook-client';

export const trackUserEvent = (eventName = '', payload = {}) => {
  Smartlook.track(eventName, payload);
};
